<template>
  <v-dialog v-model="dialog" persistent max-width="850" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        rounded
        block
        color="info"
        v-on="on"
        v-bind="attrs"
        v-if="podeAlterarIncluir"
        >Solicitar este plano</v-btn
      >
    </template>
    <anexar-docs-plano-saude
      :dependentes="getDependentesDocsAnexar()"
      :codConfig="17"
    >
      <v-spacer></v-spacer>
      <v-dialog v-model="dialogActTermos" scrollable max-width="650">
        <template v-slot:activator="{ on, attrs }">
          <v-btn min-width="200" rounded v-on="on" v-bind="attrs" color="info"
            >Confirmar documentos</v-btn
          >
        </template>
        <texto-aceitar-termos>
          <v-spacer></v-spacer>
          <v-btn
            @click="solicitarPlano()"
            rounded
            color="info"
            min-width="200"
            :disabled="!aceitouTermos"
            :loading="solicitandoPlano"
            >Solicitar plano</v-btn
          >
          <v-btn text @click="dialogActTermos = false" rounded>Fechar</v-btn>
        </texto-aceitar-termos>
      </v-dialog>
      <v-btn rounded text @click="dialog = false">Fechar</v-btn>
    </anexar-docs-plano-saude>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import AnexarDocsPlanoSaude from "../components/AnexarDocsPlanoSaude.vue";
import TextoAceitarTermos from "../components/TextoAceitarTermos.vue";
export default {
  watch: {
    dialog: function (open) {
      if (open) {
        this.setDocsAnexados([]);
      }
    },
    dialogActTermos: async function (open) {
      if (open) {
        this.setAceitouTermos(false);
        await this.getTextoAceitarTermos();
      }
    },
  },
  computed: mapState("planoSaude", [
    "aceitouTermos",
    "docsAnexados",
    "podeAlterarIncluir",
    "simulador",
  ]),
  components: {
    AnexarDocsPlanoSaude,
    TextoAceitarTermos,
  },
  data: () => ({
    dialog: false,
    dialogActTermos: false,
    solicitandoPlano: false,
  }),
  methods: {
    ...mapMutations("planoSaude", ["setDocsAnexados", "setAceitouTermos"]),
    ...mapGetters("planoSaude", ["getterPlanoSelecionado"]),
    ...mapActions("planoSaude", ["getTextoAceitarTermos"]),
    getDependentesDocsAnexar() {
      return this.getterPlanoSelecionado().dependentes.filter(
        (dep) => dep.selecionado
      );
    },
    async solicitarPlano() {
      this.solicitandoPlano = true;

      await axios
        .post(
          "/colaborador/plano-saude/solicitar-plano",
          JSON.stringify({
            documentos: this.docsAnexados,
            dependentes: this.getterPlanoSelecionado().dependentes,
            codigo: this.getterPlanoSelecionado().codigo,
            ambiente: "WEB",
          })
        )
        .then((res) => {
          if (res.data.success) {
            this.$router.push({ path: "/plano-saude" });
          } else {
            this.$toasted.error(res.data.msg);
          }
        })
        .catch((e) => this.$toasted.error(e));
      this.solicitandoPlano = false;
    },
  },
};
</script>

<style>
</style>